import { TopNavType } from "./TopNav.types"

export const initState:TopNavType = {
    cellList:[],
    itemCount:0,
    logged:false,
    userName:"",
    fb_link:""
}
